import strings from 'strings';

const { declinationReasons: STRINGS } = strings.sendoutsV2.drawers;

export const getStatusReasonText = item => {
  if (typeof item === 'string') return item;

  return item?.title || '';
};

export const buildStatusReasonItems = details => {
  const declinedFields = (details?.declined_fields || []).map(getStatusReasonText).filter(Boolean);
  const declinationNotes = details?.declination_notes;

  if (!declinedFields.length) return [];

  const reasons = declinationNotes
    ? declinedFields.filter(item => item !== STRINGS.title.otherReason)
    : [...declinedFields];

  if (declinationNotes) {
    reasons.push(`${STRINGS.title.otherReason}: ${declinationNotes}`);
  }

  return reasons;
};
